import { render } from "./EditSubRoute.vue?vue&type=template&id=7457e6d7"
import script from "./EditSubRoute.vue?vue&type=script&lang=js"
export * from "./EditSubRoute.vue?vue&type=script&lang=js"
script.render = render

export default script